module.exports = __webpack_public_path__ + "static/media/tv.c1b24070.jpg";